import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import useHttpClient from './useHttpClient';

export interface ICreateNoteData {
  noteId: { partner: string; };
  projectId: { native: number; };
  body: string;
  documents: { native: number; }[];
  authorId: {
    native: number;
  };
}

interface INoteResponse {
  noteId: {
    native: number;
  };
}

export interface INotePayload {
  addNote: (noteData: ICreateNoteData) => Promise<INoteResponse>;
  loading: boolean;
  error?: Error;
  called: boolean;
  noteResponse?: {
    noteId: {
      native: number;
    };
  };
}

const useCreateNoteForDoc = (): INotePayload => {
  const httpClient = useHttpClient();
  const queryClient = useQueryClient();

  const { mutateAsync, error, isPending, isSuccess, isError, data } = useMutation({
    mutationFn: async (noteData: ICreateNoteData) => {
      const response = await httpClient.post('/notes', noteData);
      return response.data as INoteResponse;
    },
    onSuccess: () => {
      // Invalidate note queries and note comments
      queryClient.invalidateQueries(['note']);
      queryClient.invalidateQueries(['noteComments']);
    },
  });

  const addNote = useCallback(async (noteData: ICreateNoteData) => {
    return mutateAsync(noteData);
  }, [mutateAsync]);

  return {
    addNote,
    error: error as Error,
    loading: isPending,
    called: isSuccess || isError,
    noteResponse: data,
  };
};

export default useCreateNoteForDoc;